var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CssBaseline = void 0;
var CssBaseline_1 = __importDefault(require("@material-ui/core/CssBaseline"));
exports.CssBaseline = CssBaseline_1.default;
exports.default = exports.CssBaseline;
//# sourceMappingURL=CssBaseline.js.map